import { configReducer } from '../../store/config/config.reducer';
import { footerReducer } from '../../store/footer/footer.reducer';
import { homePageReducer } from '../../store/template/homePage/homePage.reducer';
import {
    getAdSlots,
    getCategory, getDfpProperty,
    getHeaderBidderPublisherID,
    getLanguage, getPageType,
    getSiteName,
} from '../../store/config/config.selectors';
import { TemplateRegistration } from '../templateRegistration';
import { AppState } from '../../store/initialStateRegistration';
import { INJECT_VIDEO_LOGO, INJECT_BUTTON_TO_FOOTER_LINKS_SECTION, INJECT_BUTTON_TO_MENU } from '../../client/clientAPI/events';
import { getCountryCode } from '../templates.utils';
import { HomePage90minComponent } from './HomePage90minComponent';
import { headerWithSubMenusReducer } from '../../store/headerWithSubMenus/headerWithSubMenus.reducer';

export const rootReducer = {
    config: configReducer,
    footer: footerReducer,
    headerWithSubMenus: headerWithSubMenusReducer,
    template: homePageReducer,
};

const getCoreParams = (state: AppState) => ({
    property: getSiteName(state),
    language: getLanguage(state),
    category: getCategory(state),
    pageType: getPageType(state),
    adSlots: getAdSlots(state),
    headerBidderPublisherID: getHeaderBidderPublisherID(state),
    countryCode: getCountryCode(),
    dfpProperty: getDfpProperty(state),
});

export const HomePage90min = new TemplateRegistration()
    .setComponent(HomePage90minComponent)
    .setRootReducer(rootReducer)
    .setCoreParams(getCoreParams)
    .addClientAPIEvent(INJECT_VIDEO_LOGO)
    .addClientAPIEvent(INJECT_BUTTON_TO_FOOTER_LINKS_SECTION)
    .addClientAPIEvent(INJECT_BUTTON_TO_MENU)
    .build();
